/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable function-paren-newline, no-extra-boolean-cast */
import { ApiActions } from '@orientaction/api-actions';
import { apiState } from '@orientaction/reducers';
import { EqualityVariable } from '@orientaction/services';
import { useDispatch, useSelector } from 'react-redux';
import { getFromLS } from '../utils/utils';
import groupBy from 'lodash/groupBy';

// interface dataApi {
//   // 
// }

const useEquilityVariable = () => {
  const dispatch = useDispatch();
  // const data: dataApi = useSelector(apiState);
  const token = getFromLS('userToken') || '';

  const getEqualityVariable = async (filter: string) => {
    const equility = await EqualityVariable.getEqualityVariable(token, filter);
    return equility.data?.data;
  };

  return {
    getEqualityVariable,
  };
};

export default useEquilityVariable;
